import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';

const { baseUrl } = config;

export const verifyDocument = async (type, value, ifsc, dateOfBirth) => {
  try {
    const bodyParams = {
      verification_Identity_Enum: type,
      verification_Identity_Value: value,
    };

    if (ifsc) {
      bodyParams.bank_Account_IFSC = ifsc;
    }

    if (dateOfBirth) {
      bodyParams.date_of_birth = dateOfBirth;
    }

    const url = `${baseUrl}/BioFuelThirdPartyIntegration/api/SimplifiedKYC/VerifyDocumentByGovernmentId`;

    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(bodyParams),
    }).ready;

    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err) {
    console.log('api-kyc-verifyDocument->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'VerifyDocumentByGovernmentId');
    throw errors;
  }
};

export const checkDocumentExists = async (type, value, ifsc, dateOfBirth) => {
  try {
    const bodyParams = {
      verification_Identity_Enum: type,
      verification_Identity_Value: value,
    };

    if (ifsc) {
      bodyParams.bank_Account_IFSC = ifsc;
    }

    if (dateOfBirth) {
      bodyParams.date_Of_Birth = dateOfBirth;
    }

    const url = `${baseUrl}/BioFuelThirdPartyIntegration/api/SimplifiedKYC/VerifyGovermentIdAlreadyExists`;

    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(bodyParams),
    }).ready;

    const resData = await utils.processApiRes(res);
    console.log('resData---->456', resData);
    return resData;
  } catch (err) {
    console.log('api-kyc-checkDocumentExists->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'VerifyGovermentIdAlreadyExists');
    throw errors;
  }
};

export default {
  verifyDocument,
  checkDocumentExists,
};
